export default __webpack_public_path__ + "static/cyber-lisa-e38db923f0d6c1ca355b9d65c072644e.jpg";